<div class="px-0 nav-wrap">
  <div class="navigation-wrap">
    <a routerLink="/dashboard" rel="noopener noreferrer">
      <img class="logo" src="../../../../assets/images/logos/ca_us/InsureShield_Logo_226x79_larger_tagline-01.png"
        alt="{{ 'billing.method.altUps' | translate }}">
    </a>
    <div class="profile-icon" *ngIf="isInternalUser"> <!-- Internal User logic only -->
      <mat-list-item>
        <button class="round-button" #clickMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="clickMenu" #tooltip="matTooltip" [matTooltip]="loginName"
          [matTooltipHideDelay]="5000">
          {{ fName | titlecase }}
        </button>
        <mat-menu overlapTrigger="false" #clickMenu="matMenu">
          <button mat-menu-item (click)="logout()">
            {{ 'app.header.accountitems.logout' | translate }}
          </button>
        </mat-menu>
      </mat-list-item>
    </div>
  </div>
</div>
<div class="main">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<div class="px-0 backGroundFooter">
  <upsc-footer></upsc-footer>
</div>